import {
	isQuestionEffort,
	isQuestionEffortAllowed,
} from "~/modules/shared/gvtui/organisms/QuestionBox/questionEfforts.ts";
import type { AcceptedEffortUpgrade } from "~/modules/shared/gvtui/organisms/QuestionBox/useUpgradableEffort.ts";
import type { InteractionState } from "./chatPanelState.ts";

/**
 * The latest effort upgrade accepted while the page was open: one replayed
 * from history was a choice for a question long since answered.
 */
export function latestAcceptedEffortUpgrade(
	interactions: readonly InteractionState[],
): AcceptedEffortUpgrade | undefined {
	for (const interaction of [...interactions].reverse()) {
		const resolution = interaction.answer?.effortUpgradeResolution;
		if (
			resolution?.live &&
			resolution.outcome === "upgrade_accepted" &&
			isQuestionEffort(resolution.resolvedEffort) &&
			isQuestionEffortAllowed(resolution.resolvedEffort)
		) {
			return {
				requestId: resolution.requestId,
				effort: resolution.resolvedEffort,
			};
		}
	}
	return undefined;
}
